import { get, isFunction, isString } from "lodash";
import moment from "moment";
import { formatAccountCurrency, formatCurrency } from "./util";

const Contact_First_Name = "Contact.FirstName";
const Contact_Last_Name = "Contact.LastName";
const Contact_Name = "Contact.Name";
const Trading_Name = (v) => v.Organisation.LegalName || v.Organisation.Name;
const Reference = "Reference";
const Month_Year = (v) => moment(v.Date).format("MMMM YYYY");
const Month = (v) => moment(v.Date).format("MMMM");
const Week_Year = (v) => moment(v.Date).format("ww YYYY");
const Week = (v) => moment(v.Date).format("ww");
const Year = (v) => moment(v.Date).format("YYYY");
const Currency_Code = "CurrencyCode";
const Invoice_Number = "InvoiceNumber";
const Period = "Period";

export const mappings = {
  SALES_INVOICE: {
    Amount_Due_Without_Currency: (v) => formatCurrency(v.AmountDue),
    Amount_Due: (v) => `${formatCurrency(v.AmountDue)} ${v.CurrencyCode}`,
    Contact_First_Name,
    Invoice_Number,
    Contact_Last_Name,
    Contact_Name,
    Currency_Code,
    Due_Date: "DueDateString",
    Invoice_Total_Without_Currency: (v) => formatCurrency(v.Total),
    Invoice_Total: (v) => `${formatCurrency(v.Total)} ${v.CurrencyCode}`,
    Month_Year,
    Year,
    Week,
    Week_Year,
    Reference,
    Trading_Name,
  },
  BULK_INVOICES: {
    Amount_Due_Without_Currency: (v) => formatCurrency(v.AmountDue),
    Amount_Due: (v) => `${formatCurrency(v.AmountDue)} ${v.CurrencyCode}`,
    Contact_First_Name,
    Invoice_Numbers:  (v) => Object.values(v).slice(0, -1).map(invoice => invoice.InvoiceNumber).join(', '),
    Contact_Last_Name,
    Contact_Name,
    Currency_Code,
    Due_Date: "DueDateString",
    Invoice_Total_Without_Currency: (v) => formatCurrency(v.Total),
    Invoice_Total: (v) => `${formatCurrency(v.Total)} ${v.CurrencyCode}`,
    Month_Year,
    Year,
    Week,
    Week_Year,
    Reference,
    Trading_Name,
  },
  BILLS: {
    Amount_Due_Without_Currency: (v) => formatCurrency(v.AmountDue),
    Amount_Due: (v) => `${formatCurrency(v.AmountDue)} ${v.CurrencyCode}`,
    Contact_First_Name,
    Invoice_Number,
    Contact_Last_Name,
    Contact_Name,
    Currency_Code,
    Due_Date: "DueDateString",
    Invoice_Total_Without_Currency: (v) => formatCurrency(v.Total),
    Invoice_Total: (v) => `${formatCurrency(v.Total)} ${v.CurrencyCode}`,
    Month_Year,
    Year,
    Week,
    Week_Year,
    Reference,
    Trading_Name,
  },
  QUOTE: {
    Contact_First_Name,
    Contact_Last_Name,
    Contact_Name,
    Currency_Code,
    Quote_Number: "QuoteNumber",
    Quote_Total_Without_Currency: (v) => formatCurrency(v.Total),
    Terms: "Terms",
    Reference,
    Trading_Name,
  },
  CREDIT_NOTE: {
    Contact_First_Name,
    Contact_Last_Name,
    Contact_Name,
    Credit_Total_Without_Currency: (v) => formatCurrency(v.Total),
    Credit_Total: (v) => `${formatCurrency(v.Total)} ${v.CurrencyCode}`,

    Invoice_Number: "CreditNoteNumber",
    Month_Year,
    Month,
    Reference,
    Remaining_Credit_Without_Currency: (v) => formatCurrency(v.RemainingCredit),
    Remaining_Credit: (v) =>
      `${formatCurrency(v.RemainingCredit)} ${v.CurrencyCode}`,
    Trading_Name,
    Week_Year,
    Week,
    Year,
  },
  PURCHASE_ORDER: {
    Contact_First_Name,
    Contact_Last_Name,
    Contact_Name,
    Currency_Code,
    Delivery_Address: "DeliveryAddress",
    Delivery_Contact: "AttentionTo",
    Delivery_Date: "DeliveryDate",
    //Delivery_Details: 'XXXX',
    Delivery_Instructions: "DeliveryInstructions",
    Delivery_Phone_Number: "Telephone",
    Month_Year,
    Month,
    Purchase_Order_Number: "PurchaseOrderNumber",
    Purchase_Order_Total_Without_Currency: (v) => formatCurrency(v.Total),
    Purchase_Order_Total: (v) => `${formatCurrency(v.Total)} ${v.CurrencyCode}`,
    Reference,
    Trading_Name,
    Week_Year,
    Week,
    Year,
  },
  REMITTANCE: {
    Contact_First_Name,
    Contact_Last_Name,
    Contact_Name,
    Currency_Code,
    Supplier_Total_Without_Currency: (v) => formatCurrency(v.Amount),
    Supplier_Total: (v) =>
      `${formatCurrency(v.Amount)} ${get(v, "Invoice.CurrencyCode")}`,
    Trading_Name,
  },
  RECEIPT: {
    Contact_First_Name,
    Contact_Last_Name,
    Contact_Name,
    Currency_Code,
    Customer_Total_Without_Currency: (v) => formatCurrency(v.Amount),
    Customer_Total: (v) =>
      `${formatCurrency(v.Amount)} ${get(v, "Invoice.CurrencyCode")}`,
    Trading_Name,
  },
  STATEMENT: {
    Contact_First_Name,
    Contact_Last_Name,
    Contact_Name,
    Statement_Balance: (v) => (v) => {
      v.grouped
        .map((i) => `${formatAccountCurrency(i.balanceDueDue)} ${i.currency}`)
        .join(", ");
    },
    Statement_Date: "date",
    Trading_Name,
  },
  PAY_SLIP: {
    Contact_Name,
    Contact_First_Name,
    Contact_Last_Name,
    Period,
  },
  GENERIC_LINES: {
    Contact_Name,
    Contact_First_Name,
    Contact_Last_Name,
  },
};

export const populateTemplate = (text, type, data) => {
  const re = /\[(.*?)]/g;
  let result = text;
  let m = null;
  const map = mappings[type];
  if (!map) {
    throw new Error("Invalid type");
  }

  while ((m = re.exec(text))) {
    const fullTag = m[0];
    const tag = m[1];
    const replacer = map[tag];
    let replace = null;

    try {
      if (isFunction(replacer)) {
        replace = replacer(data);
      } else if (isString) {
        replace = get(data, replacer);
      }
    } catch (err) {}

    result = result.replace(fullTag, replace || "");
  }

  return result;
};
